/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/zh/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zh/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zh/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zh/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zh/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/zh/preview-05.webp'),
    },
  ],
};
